module.exports = __webpack_public_path__ + "img/mp-flows-exp.a8af44dd.jpg";